import { FC, useState } from "react";
import { Tabs } from "@/ui";
import FilesLinks from "../FilesLinks";
import Messages from "../Messages";

enum TabKeys {
  messages = 'messages',
  files = 'files',
}

const Details: FC = () => {
  const [active, setActive] = useState(TabKeys.messages);

  const onChange = (value: TabKeys) => setActive(value);

  const renderContent = () => {
    switch (active) {
      case TabKeys.messages:
        return <Messages />;
      case TabKeys.files:
        return <FilesLinks />;
      default:
        return null;
    }
  };

  return (
    <>
      <Tabs
        data={[
          {
            label: 'messages',
            key: TabKeys.messages,
          },
          {
            label: 'files_and_links',
            key: TabKeys.files,
          },
        ]}
        active={active}
        onChange={onChange}
      />
      {renderContent()}
    </>
  );
};

export default Details;
